import z from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import type { SourceId } from "view/dashboard/widgets/sources";
import type { VisualId } from "view/dashboard/widgets/visuals";
import { Permission } from "__generated__/enums";

// Base configuration each widget has
export const baseConfigSchema = z.object({
	label: z.string(),
	url: z.string(),
});

export type BaseConfig = z.infer<typeof baseConfigSchema>;

// A widget as it is stored in the user preferences or on the organisation dashboard
export const storedWidgetSchema = z.object({
	id: z.string(),
	source: z.custom<SourceId>(value => typeof value === "string"),
	visual: z.custom<VisualId>(value => typeof value === "string"),
	config: baseConfigSchema.extend({
		source: z.unknown(),
		visual: z.unknown(),
	}),
	order: z.number(),
});

export type StoredWidgetSchemaInput = z.input<typeof storedWidgetSchema>;
export type StoredWidgetSchemaOutput = z.output<typeof storedWidgetSchema>;

export const widgetSaveDefaultSchema = z.object({
	permission: ZodSchema.requiredField(z.enum(Permission)),
});

export type WidgetSaveDefaultSchemaInput = z.input<typeof widgetSaveDefaultSchema>;
export type WidgetSaveDefaultSchemaOutput = z.output<typeof widgetSaveDefaultSchema>;
